import { __assign, __extends } from "tslib";
import { namespacedClassnames } from '../../../common/namespace-classes';
import * as React from 'react';
import { ReactSelectAsync, ReactSelect3, ReactSelect3Components } from './../../../common/react-select';
import { LibColor } from '../../../new-libby/core/colors/colors-map';
import { selectV3Styles } from './select-v3-styles';
import { Tooltip } from '../..';
var defaultProps = {
    disabled: false,
    searchable: true,
    openOnFocus: true,
    clearable: false,
    autosize: false
};
var defaultV3Props = {
    disabled: false,
    searchable: true,
    openMenuOnFocus: true,
    clearable: false,
    autosize: false
};
var getChevronIcon = function (isDisabled) {
    var iconColor = isDisabled ? LibColor.grey100 : LibColor.blue100;
    return (React.createElement("svg", { width: '9', height: '8', viewBox: '0 0 9 8', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        React.createElement("path", { "fill-rule": 'evenodd', "clip-rule": 'evenodd', d: 'M0.403809 2.25842L1.90896 0.941406L4.65639 4.08132L7.40381 0.941406L8.90896 2.25842L4.65639 7.1185L0.403809 2.25842Z', fill: iconColor })));
};
var Select = /** @class */ (function (_super) {
    __extends(Select, _super);
    function Select() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fakeLoadOptions = function (_, cb) {
            cb(null, { options: _this.props.options });
        };
        _this.formatOptionLabel = function (data, context) {
            if (context.context === 'menu') {
                return _this.props.optionRenderer ? _this.props.optionRenderer(data) : data.label;
            }
            else {
                return _this.props.valueRenderer ? _this.props.valueRenderer(data) : data.label;
            }
        };
        // avoids blowup when onInputChange passed as async - https://app.asana.com/0/1198918337991486/1199694602056889/f
        _this.onInputChange = function (term) {
            if (_this.props.onInputChange) {
                _this.props.onInputChange(term);
            }
        };
        _this.renderV3 = function () {
            var _a;
            var props = _this.props;
            var valueV3 = ((_a = props.value) === null || _a === void 0 ? void 0 : _a.value) !== undefined ?
                props.value : props.options.find(function (option) { return option.value === props.value; });
            var optionsV3 = props.options.map(function (o) { return o.disabled ? __assign(__assign({}, o), { isDisabled: o.disabled }) : o; });
            var DropdownIndicator = function (dropdownProps) {
                return (React.createElement(ReactSelect3Components.DropdownIndicator, __assign({}, dropdownProps), getChevronIcon(!!props.disabled)));
            };
            var IndicatorSeparator = function (_) { return null; };
            var NoOptionsMessage = function () {
                var noOptionStyle = { fontSize: '14px', fontWeight: 300, padding: '6px 12px', color: "" + LibColor.grey100 };
                var noResultsTextElem = typeof props.noResultsText === 'string'
                    ? React.createElement("div", { className: 'no-results-v3', style: noOptionStyle }, props.noResultsText)
                    : props.noResultsText;
                return noResultsTextElem || React.createElement("div", { style: noOptionStyle }, "No results found");
            };
            var Option = function (optionProps) {
                return React.createElement(ReactSelect3Components.Option, __assign({}, optionProps, { className: optionProps.data.className }));
            };
            var SingleValue = function (optionProps) {
                return React.createElement(ReactSelect3Components.SingleValue, __assign({}, optionProps, { className: optionProps.data.className }));
            };
            var classNamesV3 = namespacedClassnames('new-select', props.className, { small: _this.props.size === 'small' });
            var maybeMenuPortal = props.menuPortalTarget ? {
                menuPortalTarget: props.menuPortalTarget,
                // tslint:disable-next-line: max-line-length
                menuShouldBlockScroll: true // Issue with menu repositioning on scroll so we need this - https://github.com/JedWatson/react-select/issues/4088
            } : {};
            return (React.createElement(ReactSelect3, __assign({}, defaultV3Props, maybeMenuPortal, { value: valueV3, options: optionsV3, onChange: props.onChange, placeholder: props.placeholder, isDisabled: !!props.disabled, classNamePrefix: 'select-v3', className: classNamesV3, components: { DropdownIndicator: DropdownIndicator, IndicatorSeparator: IndicatorSeparator, NoOptionsMessage: NoOptionsMessage, Option: Option, SingleValue: SingleValue }, styles: selectV3Styles(_this.props.size, _this.props.menuPlacement), blurInputOnSelect: true, isSearchable: props.searchable, onBlur: props.onBlur, onFocus: props.onFocus, onMenuOpen: props.onOpen, onMenuClose: props.onClose, onInputChange: _this.onInputChange, autoFocus: props.autoFocus, formatOptionLabel: _this.formatOptionLabel, menuPlacement: props.menuPlacement, menuShouldScrollIntoView: true, maxMenuHeight: 172 })));
        };
        _this.shouldRenderWithTooltip = function (disabled) {
            return !!disabled && typeof disabled !== 'boolean';
        };
        return _this;
    }
    Select.prototype.render = function () {
        var props = __assign(__assign(__assign({}, defaultProps), this.props), { 
            // This is needed when options are loaded async (like user search)
            // https://github.com/JedWatson/react-select/issues/761
            filterOption: this.props.disableOptionFiltering ? function () { return true; } : undefined });
        var isV3Enabled = false;
        try {
            isV3Enabled = this.props.useSelectV3 !== undefined
                ? this.props.useSelectV3
                : typeof window !== 'undefined' && window.localStorage.getItem('__aex_selectV3') === 'true';
        }
        catch (e) {
            console.info('using select v1');
        }
        var classNames = namespacedClassnames('select', props.className, { small: this.props.size });
        var noResultsText = props.noResultsText || 'No results found';
        var regularSelect = (React.createElement(ReactSelectAsync, __assign({}, props, { noResultsText: noResultsText, loadOptions: this.fakeLoadOptions, onSelectResetsInput: false, onBlurResetsInput: false, className: classNames })));
        var selectComp = isV3Enabled ? this.renderV3() : regularSelect;
        return this.shouldRenderWithTooltip(this.props.disabled) ?
            React.createElement(Tooltip, { body: this.props.disabled, relativeToBody: true, className: 'disabled-select-tooltip' }, selectComp) :
            selectComp;
    };
    return Select;
}(React.PureComponent));
export { Select };
//# sourceMappingURL=select.js.map